<template>
  <card>
    <h4 slot="header" class="card-title">Edit User</h4>
    <form>
      <div class="row">
        <div class="col-md-4">
          <base-input type="text" label="Name" :disabled="true" placeholder="Name" v-model="userData.name">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="email" label="Email" :disabled="true" placeholder="Email" v-model="userData.email">
          </base-input>
        </div>
      </div>
      <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Team</label>
              <select name="team_id" class="form-control" v-model="userData.team_id">
                <option v-for="team in teams" :selected="(userData.team_id == team.id)?true:false" :value="team.id">{{team.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Role</label>
              <select name="role" class="form-control" v-model="userData.role">
                <option v-for="role in roles" :selected="(userData.role == role)?true:false" :value="role">{{role}}</option>
              </select>
            </div>
          </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <button type="button" v-on:click="submit()"  class="btn btn-success submit">Save Changes</button>
        </div>
      </div>

      <div class="clearfix"></div>
    </form>
  </card>
</template>

<script>
import Card from 'src/components/Cards/Card.vue'

import axios from "axios";

export default {
  components: {
    Card
  },
  props: ['user'],
  data() {
    return {
      userData: {},
      teams: {},
      accessToken: null,
      loading: true,
      selected: null,
      roles: ['Admin', 'User']
    }
  },
  async created() {
    try {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData();
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    loadData() {
      axios.get('user/edit/'+ this.$route.params.userId +'?access_token=' + this.accessToken, {})
        .then(response => (
            this.userData = response.data.user[0],
            this.teams = response.data.teams,
            this.loading = false
        ));
    },
    submit() {
      axios
        .post('user/edit/'+ this.$route.params.userId +'?access_token=' + this.accessToken, this.userData)
        .then(function (response){
          if (response.status == 200){
            alert("Changes saved.")
          }
        }.bind(this))
    }
  }
}
</script>

<style>

</style>
